import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CheckboxModule } from 'primeng/checkbox';
import { StyleClassModule } from 'primeng/styleclass';
import { CardModule } from 'primeng/card';
import { HomeComponent } from './home/home.component';
import { ButtonModule } from 'primeng/button';
import { AvatarModule } from 'primeng/avatar';
import { InputTextModule } from 'primeng/inputtext';
import { MegaMenuModule } from 'primeng/megamenu';
import { MessagesModule } from 'primeng/messages';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { MenuModule } from 'primeng/menu';
import { PanelMenuModule } from 'primeng/panelmenu';
import { SharedModule } from '../shared/components/shared.module';
import { AppConfig } from './app.config';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from '@angular/common/http';
import { MainHeaderComponent } from './main-header/main-header.component';
import { UserModule } from './user/user.module';
import { AuthInterceptor } from 'src/core/Interceptors/auth.interceptor';
import { ErrorInterceptor } from 'src/core/Interceptors/error.interceptor';
import { SpinnerInterceptor } from 'src/core/Interceptors/spinner.interceptor';
import { NgProgressModule } from 'ngx-progressbar';
import { TooltipModule } from 'primeng/tooltip';
import { RefreshTokenService } from 'src/core/services/refresh-token.service';
import { registerLocaleData } from '@angular/common';
import localeDa from '@angular/common/locales/da';
import { LoginComponent } from './user/login/login.component';
import { SignupComponent } from './user/signup/signup.component';
import { FinanceModule } from './finance/finance.module';
import { DistributionModule } from './distributions/distributions.module';
import { MaintenancePageComponent } from './maintenance-page/maintenance-page.component';
import * as Sentry from "@sentry/angular-ivy";
import { Router } from '@angular/router';
import { CustomDatetimePipe } from 'src/core/helpers/custom-pipe/CustomDatetimePipe.pipe';
import { NgxSummernoteModule } from 'ngx-summernote';
import { GeneralSettingsComponent } from './Settings/general-settings/general-settings.component';
import { CompanySettingsComponent } from './Settings/company-settings/company-settings.component';
import { MembersComponent } from './Settings/members/members.component';
import { SuperAdminSettingsComponent } from './Settings/super-admin-settings/super-admin-settings.component';
import { AdvancedComponent } from './Settings/advanced/advanced.component';
import { LabelListComponent } from './label-list/label-list.component';
registerLocaleData(localeDa);
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, '../assets/translation/', '.json');
}

export function initializeApp(appConfig: AppConfig) {
  return () => appConfig.load();
}
@NgModule({  declarations: [
    AppComponent,
    HomeComponent,
    MainHeaderComponent,
    LoginComponent,
    SignupComponent,
    MaintenancePageComponent,
    GeneralSettingsComponent,
    CompanySettingsComponent,
    MembersComponent,
    SuperAdminSettingsComponent,
    AdvancedComponent,
    LabelListComponent,
    ],
  providers: [
    AppConfig,
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfig, Sentry.TraceService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      deps: [AppConfig],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SpinnerInterceptor,
      multi: true,
    },
    MessageService,
    RefreshTokenService
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    CheckboxModule,
    StyleClassModule,
    CardModule,
    ButtonModule,
    AvatarModule,
    InputTextModule,
    MegaMenuModule,
    MessagesModule,
    ToastModule,
    MenuModule,
    PanelMenuModule,
    SharedModule,
    UserModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    TooltipModule,
    FinanceModule,
    DistributionModule,
    NgxSummernoteModule,
    NgProgressModule
  ],
})
export class AppModule {}
